import axiosInstance from "@/lib/axios";

export const serviceCategoryService = {
  // Liste complète (actives + inactives) pour la gestion admin
  getCategories: async () => {
    const response = await axiosInstance.get('/api/v1/admin/service-categories');
    return response.data;
  },

  createCategory: async (data) => {
    const response = await axiosInstance.post('/api/v1/admin/service-categories', data);
    return response.data;
  },

  updateCategory: async (id, data) => {
    const response = await axiosInstance.put(`/api/v1/admin/service-categories/${id}`, data);
    return response.data;
  },

  deleteCategory: async (id) => {
    const response = await axiosInstance.delete(`/api/v1/admin/service-categories/${id}`);
    return response.data;
  },

  toggleActive: async (id) => {
    const response = await axiosInstance.patch(`/api/v1/admin/service-categories/${id}/toggle-active`);
    return response.data;
  },
};
